export function arrayPushUnique(
  arr: any[],
  uniqueKey: string,
  items: any[] = [],
) {
  if (!arr || arr?.length === 0) return items

  // 새로운 배열을 만들어서 기존 items를 복사
  const result = items ? [...items] : []

  arr.forEach((item) => {
    const existingIndex = result.findIndex(
      (i) => i[uniqueKey] === item[uniqueKey],
    )
    if (existingIndex !== -1) {
      // 기존 항목을 새 항목으로 교체 (최신 데이터 우선)
      result[existingIndex] = item
    } else {
      result.push(item)
    }
  })
  return result
}
